if (!customElements.get('pdf-email-gate')) {
  customElements.define(
    'pdf-email-gate',
    class PdfEmailGate extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.submitButton = this.querySelector('[type="submit"]');
        this.emailInput = this.querySelector('input[type="email"]');
        this.formWrapper = this.querySelector('.pdf-email-gate__form');
        this.successWrapper = this.querySelector('.pdf-email-gate__success');
        this.errorMessage = this.querySelector('.pdf-email-gate__error-js');
        this.loadingSpinner = this.querySelector('.loading__spinner');

        if (this.dataset.posted === 'true') {
          this.showSuccess();
          this.trackLead('native_form');
        } else {
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        }
      }

      static get BLOCKED_DOMAINS() {
        return [
          'mailinator.com',
          'guerrillamail.com',
          'tempmail.com',
          'throwaway.email',
          'yopmail.com',
          'sharklasers.com',
          'guerrillamailblock.com',
          'grr.la',
          'dispostable.com',
          'trashmail.com',
          'fakeinbox.com',
          'maildrop.cc',
          'temp-mail.org',
          'getnada.com',
          'mailnesia.com',
          'example.com',
        ];
      }

      validateEmail(email) {
        const trimmed = email.trim().toLowerCase();

        if (!trimmed || !trimmed.includes('@')) return false;

        const domain = trimmed.split('@')[1];
        if (!domain || !domain.includes('.')) return false;

        if (PdfEmailGate.BLOCKED_DOMAINS.includes(domain)) {
          return false;
        }

        const localPart = trimmed.split('@')[0];
        if (localPart === 'test' && domain === 'test.com') return false;
        if (localPart.length <= 1 && domain.length <= 3) return false;

        return true;
      }

      showError(message) {
        if (this.errorMessage) {
          this.errorMessage.textContent = message;
          this.errorMessage.removeAttribute('hidden');
        }
      }

      hideError() {
        if (this.errorMessage) {
          this.errorMessage.setAttribute('hidden', '');
        }
      }

      trackLead(method) {
        if (typeof gtag === 'function') {
          gtag('event', 'generate_lead', {
            event_category: 'pdf_download',
            event_label: document.title,
            method: method,
          });
        }
      }

      showSuccess() {
        if (this.formWrapper) this.formWrapper.setAttribute('hidden', '');
        if (this.successWrapper) this.successWrapper.removeAttribute('hidden');
      }

      nativeSubmit() {
        this.form.removeEventListener('submit', this.onSubmitHandler.bind(this));
        this.form.submit();
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        evt.stopImmediatePropagation();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.hideError();

        const email = this.emailInput.value;
        if (!this.validateEmail(email)) {
          this.showError('Please enter a valid email address.');
          return;
        }

        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');
        if (this.loadingSpinner) this.loadingSpinner.classList.remove('hidden');

        const formData = new FormData(this.form);

        fetch(this.form.action, {
          method: 'POST',
          body: formData,
          redirect: 'manual',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
        })
          .then((response) => {
            if (response.type === 'opaqueredirect' || response.ok || response.redirected) {
              this.showSuccess();
              this.trackLead('ajax');
            } else {
              this.nativeSubmit();
            }
          })
          .catch(() => {
            this.nativeSubmit();
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            if (this.loadingSpinner) this.loadingSpinner.classList.add('hidden');
          });
      }
    }
  );
}
